// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__xM5Ai","error":"styles_error__Y4oWV","month":"styles_month__krpH5","div_text":"styles_div_text__RcTuj","text":"styles_text__zcTrJ"};